export const BUSINESS = {
  name: "F&C Air Conditioning",
  phone: "305-724-9995",
  phoneHref: "tel:13057249995",
  email: "nfrantz@fcairconditionings.com",
  owner: "Frantz Noel",
  license: "CAC1825191",
  licenseExpiration: "August 31, 2028",
  domain: "fcairconditionings.com",
};

export const SERVICES = [
  { n: "01", title: "Air Conditioning", desc: "Professional cooling services for residential and commercial needs.", cta: "Request Service" },
  { n: "02", title: "AC Repair", desc: "Service and repair when your air conditioning system is not performing properly.", cta: "Request Service" },
  { n: "03", title: "AC Installation", desc: "Installation solutions for new and replacement air conditioning systems.", cta: "Get a Quote" },
  { n: "04", title: "AC Maintenance", desc: "Routine service designed to support reliable HVAC operation.", cta: "Schedule Service" },
  { n: "05", title: "Heating", desc: "Heating services to help maintain comfortable indoor temperatures.", cta: "Request Service" },
  { n: "06", title: "Electrical", desc: "Electrical services associated with HVAC and related systems.", cta: "Request Service" },
  { n: "07", title: "Walk-In Coolers", desc: "Cooling solutions and service for commercial walk-in cooler applications.", cta: "Request Service" },
  { n: "08", title: "Commercial HVAC", desc: "HVAC solutions designed for businesses and commercial properties.", cta: "Commercial Service" },
];

export const PROCESS = [
  { n: "01", title: "Contact Us", desc: "Call or submit a service request." },
  { n: "02", title: "Assessment", desc: "We evaluate the HVAC need." },
  { n: "03", title: "Recommendation", desc: "We explain the appropriate service or solution." },
  { n: "04", title: "Service", desc: "We perform the agreed-upon work." },
];

export const COMMERCIAL_TAGS = ["Commercial AC", "Installation", "Repairs", "Service", "Walk-In Coolers", "Electrical"];
export const RESIDENTIAL_TAGS = ["AC Repair", "AC Installation", "AC Maintenance", "Heating", "System Replacement", "HVAC Service"];

export const PROPERTY_TYPES = ["Residential", "Commercial"];
export const SERVICE_OPTIONS = [
  "AC Repair", "AC Installation", "AC Maintenance", "Heating",
  "Electrical", "Walk-In Cooler", "Commercial HVAC", "Other",
];

export const PRICING = {
  residential: [
    { service: "AC Diagnostic / Service Call", price: "$125" },
    { service: "AC Maintenance / Tune-Up", price: "$179" },
    { service: "AC Repair", price: "Starting at $250" },
    { service: "Emergency / After-Hours Service", price: "Starting at $225" },
    { service: "Capacitor Replacement", price: "Starting at $175" },
    { service: "Contactor Replacement", price: "Starting at $175" },
    { service: "Thermostat Replacement", price: "Starting at $175" },
    { service: "Condensate Drain Service", price: "Starting at $150" },
    { service: "Refrigerant Service", price: "Starting at $250" },
    { service: "Blower Motor Replacement", price: "Starting at $450" },
    { service: "Evaporator Coil Replacement", price: "Starting at $1,100" },
    { service: "Compressor Replacement", price: "Starting at $1,500" },
  ],
  installation: {
    title: "AC System Replacement",
    price: "Starting at $4,500",
    desc: "Includes professional installation of a new central air conditioning system, subject to equipment selection, system size, property requirements and installation conditions.",
    cta: "Get a Free Installation Estimate",
  },
  plans: [
    {
      name: "Basic", price: "$179", period: "/ year", featured: false,
      features: [
        "1 annual HVAC maintenance visit",
        "System inspection",
        "Electrical inspection",
        "Airflow inspection",
        "Condensate drain inspection",
        "System performance check",
        "Maintenance recommendations",
      ],
    },
    {
      name: "Plus", price: "$289", period: "/ year", featured: true,
      features: [
        "2 HVAC maintenance visits",
        "System inspection",
        "Electrical inspection",
        "Condensate drain inspection",
        "Airflow inspection",
        "Performance testing",
        "Priority scheduling",
        "10% discount on qualifying repairs",
      ],
    },
    {
      name: "Premium", price: "$389", period: "/ year", featured: false,
      features: [
        "2 HVAC maintenance visits",
        "Comprehensive system inspection",
        "Electrical inspection",
        "Condensate drain service",
        "Airflow / performance testing",
        "Priority scheduling",
        "15% discount on qualifying repairs",
        "After-hours diagnostic included",
      ],
    },
  ],
  commercial: [
    { service: "Commercial Diagnostic", price: "Starting at $195", desc: "Initial system assessment and diagnosis." },
    { service: "Commercial HVAC Service", price: "Starting at $350", desc: "Final pricing based on equipment, labor, parts and scope of work." },
    { service: "Commercial HVAC Maintenance", price: "Custom Pricing", desc: "Customized by number of units, equipment type, property size, service frequency and operating hours." },
  ],
  walkin: [
    { service: "Walk-In Cooler Diagnostic", price: "Starting at $195" },
    { service: "Walk-In Cooler Repair", price: "Starting at $350" },
    { service: "Walk-In Cooler Maintenance", price: "Custom Quote" },
  ],
  electrical: [
    { service: "HVAC Electrical Diagnostic", price: "Starting at $125" },
    { service: "HVAC Electrical Repair", price: "Starting at $175" },
    { service: "Installation / Replacement", price: "Custom Quote" },
  ],
  notice: "Prices shown are starting prices and may vary depending on equipment, system condition, parts, labor, accessibility and the scope of work. A technician will evaluate the system and provide a clear estimate before additional work is performed. Additional charges may apply for emergency, after-hours or specialized services.",
};

export const IMAGES = {
  hero: "/images/van-side.webp",
  vanRear: "/images/van-rear.webp",
  technician: "/images/drain-service.webp",
  commercial: "/images/rtu-trane.webp",
  residential: "/images/air-handler.webp",
};

